export default __webpack_public_path__ + "static/media/cal-add.eea9f1ad.png";